import { useState } from 'react'
import { useAuroraStore } from '../../store/auroraStore'
import { activeChild, dueWeekCheckin, reviewFor } from '../../store/selectors'
import { todayISO } from '../../lib/dates'
import { WeekCheckin } from './WeekCheckin'

/**
 * A quiet line at the top of Today (and Progress) when a week's check-in is
 * waiting: from Sunday until it is sent. One tap opens the table.
 */
export function CheckinBanner() {
  const child = useAuroraStore(activeChild) as any
  const today = todayISO(child?.timezone)
  const due = useAuroraStore((s: any) => dueWeekCheckin(s, today))
  const review = useAuroraStore((s: any) => (due ? reviewFor(s, 'week', due.monday) : undefined))
  const [open, setOpen] = useState(false)

  if (!child || !due) return null
  const started = !!review?.parent

  return (
    <>
      <button className="checkin-banner reveal" onClick={() => setOpen(true)}>
        <span className="checkin-banner-dot" aria-hidden="true" />
        <span className="checkin-banner-text">
          <span className="checkin-banner-title">
            Week {due.week?.number ?? ''} check-in {started ? 'in progress' : 'is ready'}
          </span>
          <span className="checkin-banner-sub">
            {due.week?.theme ? `${due.week.theme} · ` : ''}two minutes: rate each area, answer the week's questions, and Sapling shapes next week.
          </span>
        </span>
        <span className="checkin-banner-cta">Open</span>
      </button>
      {open && <WeekCheckin monday={due.monday} week={due.week} open={open} onClose={() => setOpen(false)} />}
    </>
  )
}
